export const painPoints = [
  'Una carpeta con 10 años de papeles sin ningún orden, y nunca encontrás el estudio justo cuando te lo piden.',
  'Observás cosas todos los días, pero no quedan claras cuando tenés que contarlas en el consultorio.',
  'Preparás preguntas en tu cabeza y salís de la consulta habiendo olvidado la mitad.',
  'Te vas del consultorio con la sensación de haber perdido un tiempo valiosísimo que tardás meses en volver a tener.'
];

export const costs = [
  'Otro año donde el médico dice “hay que esperar” porque no tiene tus datos',
  'Otro año donde salís sin saber si el tratamiento es correcto',
  'Meses esperando porque olvidaste las 3 preguntas importantes',
  'La culpa de no comunicar lo que observás',
  'La sensación de que tu voz no importa en las decisiones'
];

export const faqs = [
  ['¿Necesito conocimientos médicos?', 'No. Solo observás y anotás con una estructura clara. El médico interpreta.'],
  ['¿Cuánto tiempo me toma?', '7 días. Una semana de pequeñas acciones diarias, con la cuenta regresiva ya armada.'],
  ['¿Cuándo veo resultados?', 'En 7 días llegás con todo en orden. Los cambios clínicos dependen del tratamiento médico.'],
  ['¿La garantía es real?', 'Sí. Tenés 7 días para probarlo. Devolución del 100%, sin formularios y sin drama.'],
  ['¿Es 100% digital?', 'Sí. Acceso inmediato por email en PDF. Podés leerlo desde el celular, tablet o computadora, e imprimirlo si preferís.']
] as const;

export const stats = [
  ['+420', 'madres usando el sistema'],
  ['4', 'Volúmenes completos'],
  ['5', 'Bonos incluidos'],
  ['4.9/5', 'calificación']
] as const;
